/* eslint-disable react-hooks/exhaustive-deps, @typescript-eslint/strict-boolean-expressions */

import { Stack } from '@mui/material';
import { useState } from 'react';

import { HiroChartDisplay } from 'components/hiro/HiroChart/HiroChartDisplay';
import { HiroSettingsBar } from 'components/hiro/HiroChart/controls/HiroSettingsBar';
import { SizeControls } from 'components/shared/SizeControls';
import { InfoButton } from 'components/shared/InfoButton';
import { SymbolTabs } from 'components/hiro/HiroChart/controls/SymbolTabs';
import { ProductType } from 'types';

import { HiroChartV2 } from 'components/hiro/HiroChartV2';
import { HiroChartV3 } from 'components/hiro/HiroChartV3';

import { useHiroCtx } from './HiroProvider';

export const HiroChartContainer = () => {
  const { sym, enableHiroV2, enableHiroV3, bottomDrawerExpanded, mode } =
    useHiroCtx();

  const [sizeControlsPopperOpen, setSizeControlsPopperOpen] = useState(false);

  return enableHiroV2 || enableHiroV3 ? (
    <Stack
      width="99%"
      height={mode === 'canvas' ? '100%' : undefined}
      pt={mode === 'canvas' ? 3 : 0}
      px={mode === 'canvas' ? 2 : 0}
    >
      {enableHiroV3 && <HiroSettingsBar />}
      <Stack flexGrow={1} direction="row">
        {mode != 'canvas' && (
          <SymbolTabs productType={ProductType.HIRO} sym={sym} />
        )}
        {!enableHiroV3 && (
          <>
            <SizeControls
              open={sizeControlsPopperOpen}
              setOpen={setSizeControlsPopperOpen}
            />
            <InfoButton key="hiro-info" articleKey="hiro-info" />
          </>
        )}
      </Stack>
      {enableHiroV3 ? <HiroChartV3 /> : <HiroChartV2 />}
    </Stack>
  ) : (
    <HiroChartDisplay key={bottomDrawerExpanded ? '1' : '0'} />
  );
};
